
export default {
    computed: {
        //启用状态
        getActive() {
            return [
                {
                    value: null,
                    label: this.$t('global.common.all', { defaultValue: '全部' }),
                },
                {
                    value: 1,
                    label: this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                },
                {
                    value: 0,
                    label: this.$t('fbb.accountmanage.disable', { defaultValue: '禁用' }),
                },
            ]
        },
        //配送类型
        getDeliveryTypes() {
            return [
                {
                    value: null,
                    label: this.$t('global.common.all', { defaultValue: '全部' }),
                },
                {
                    value: '0',
                    label: this.$t('fbb.accountmanage.express', { defaultValue: '快递' }),
                },
                {
                    value: '1',
                    label: this.$t('fbb.inbound.truck', { defaultValue: '卡车' }),
                },
            ]
        },
        //仓库类型
        getWarehouseTypes() {
            return [
                {
                    value: '1',
                    label: this.$t('fbb.warehouse.service_warehouse', { defaultValue: '服务仓' }),
                },
                {
                    value: '2',
                    label: this.$t('fbb.warehouse.fba_warehouse', { defaultValue: 'FBA仓' }),
                },
                {
                    value: '4',
                    label: this.$t('fbb.warehouse.onsite_warehouse', { defaultValue: 'onsite仓库' }),
                },
                {
                    value: '5',
                    label: this.$t('fbb.warehouse.virtual_warehouse', { defaultValue: '虚拟仓' }),
                }
            ]
        },
    },
}
